{
  "NAME": "CallRecIntegration",
  "AddCallRecIntegrationTitle": "Add Call Recording Integration",
  "ModifyCallRecIntegrationTitle": "Modify Call Recording Integration",
  "TabGeneralTitle": "General",
  "TabScopeAssignmentsTitle": "Scope Assignments",
  "TabApiCommunicationsTitle": "Api Communications",
  "TabDubberCommunicationsTitle": "Dubber Communications",
  "IdentifierGUID": "Identifier (GUID):",
  "IdentifierGUIDPlaceholder": "[Auto Assigned]",
  "IntegrationType": "Integration Type:",
  "IntegrationType_1": "[Unknown Or Unspecified Type]",
  "IntegrationType_2": "Dubber Corporation Limited",
  "ModifyCallRecIntegrationDescriptionFormLabel": "Description:",
  "DubberApiComSettingsLocationUrls": "Dubber Location URL:",
  "ApiComSettingsIPAddrOne": "IP Address 1 (MAIN):",
  "ApiComSettingsIPAddrTwo": "IP Address 2 (SECONDARY):",
  "ApiComSettingsAuthDetailsMainTitle": "Authentication Details (MAIN)",
  "ApiComSettingsAuthDetailsMainUserName": "Username (MAIN):",
  "ApiComSettingsAuthDetailsMainUserPassword": "Password (MAIN):",
  "ApiComSettingsAuthDetailsSecondaryTitle": "Authentication Details (SECONDARY):",
  "ApiComSettingsAuthDetailsSecondaryUserName": "Username (Secondary):",
  "ApiComSettingsAuthDetailsSecondaryUserPassword": "Password (Secondary):",
  "ApiComSettingsApiParamOne": "API Parameter 1:",
  "ApiComSettingsApiParamTwo": "API Parameter 2:",
  "DubberComSettingsApiParamOne": "Account Name (TRAILING PART):",
  "DubberComSettingsApiParamTWO": "Account User / E-MAIL (OPTIONAL):",
  "DubberComSettingsTitle": "Dubber Communication Settings",
  "DubberComSettingsLocationURL": "Dubber Location URL:",
  "DubberComSettingsDevAuthTitle": "Developer Authentication",
  "DubberComSettingsDevAuthUserName": "Username (MASHERYID KEY):",
  "DubberComSettingsDevAuthUserPassword": "Password (MASHERYID SECRET):",
  "DubberComSettingsAccountApiAuthTitle": "Account API Authentication",
  "DubberComSettingsAccountApiAuthUserName": "Username (API AUTH ID):",
  "DubberComSettingsAccountApiAuthUserPassword": "Password (API AUTH TOKEN):",
  "DubberComSettingAccountName": "Account Name (Trailing Part)",
  "DubberComSettingsAccountUserEmail": "Account User / Email (OPTIONAL)",
  "DubberComSettings_Parameters": "Parameters",
  "DubberComSettings_TestIntegrationAuth": "Test Integration Authentication",
  "CallRecIntegrationAddModify_UnknownOrDeleted": "[Unknown or Deleted]",
  "CallRecIntegrationAddModify_ServerErrorTitle": "Validation errors",
  "CallRecIntegrationAddModify_ValidationWarning": "Please ensure all fields are filled in correctly",
  "CallRecIntegrationAddModify_ButtonHelpLabel": "Help?",
  "CallRecIntegrationAddModify_ButtonSubmitLabel": "Save",
  "CallRecIntegrationAddModify_ButtonCancelLabel": "Cancel",
  "CallRecIntegrationAddModify_PromptMessage": "Are you sure you want to close this window? All modified configurations will be lost when closed.",
  "CallRecIntegrationAddModify_PromptConfirm": "Yes",
  "CallRecIntegrationAddModify_PromptCancel": "Cancel",
  "Error_TestIntegration_Timeout": "Test Integration sign-in timed out",
  "InputField_Change_Username": "[Change Username]",
  "InputField_Change_Password": "[Change Password]"
}